import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CustomsValidators } from '../../validators/custom.validators';
import {throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminFaqSectionService {
  urlFaqAdminSection: string;

  constructor(private http: HttpClient) {
    this.urlFaqAdminSection = `${environment.bffBaseUrl}/pages/admin-faq-section`;
  }

  getAdmFaqSection( page: number, limit: number) {
    const urlBuilder = this.urlFaqAdminSection + '?page=' + page + '&limit=' + limit + '&desc=false&isEnabled=all';
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }
  postAdmFaqSection(section) {
    const urlBuilder = this.urlFaqAdminSection;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder,
  {SectionEs: section.sectionEs, SectionEn: section.sectionEn}) : throwError(CustomsValidators.msgNotValidUrl);
  }
  putAdmFaqSection(section) {
    const urlBuilder = this.urlFaqAdminSection + '/' + section.Id;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.put(urlBuilder,
     {Id: section.Id, SectionEs: section.sectionEs, SectionEn: section.sectionEn, IsEnabled: section.isEnabled})
      : throwError(CustomsValidators.msgNotValidUrl);
  }




}
